import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

const currentMonth = format(new Date(), 'MMMM', {
  locale: enUS
}).toLowerCase();

export const TABS = [
  {
    title: `ranking.months.${currentMonth}`,
    id: '1',
    active: true
  },
  {
    title: 'ranking.tabs.general',
    id: '2',
    active: false
  }
];

export const TAB_NAME_GENERAL = 'ranking.tabs.general';
